import React from 'react';
import useTranslate from 'hooks/useTranslate';
import { useNavigate } from 'react-router-dom';

const AuthHeadingPanel: React.FC<any> = ({ description }) => {
	const { translate } = useTranslate();
	const navigate = useNavigate();
	return (
		<div className="auth-form-heading text-center">
			<h2 className="mb-1">
				{translate('Common.welcomeTo')}{' '}
				<span
					className="fw-bold"
					style={{ cursor: 'pointer' }}
					onClick={() => {
						navigate('/');
					}}
				>
					{translate('Common.jobstas')}
				</span>
			</h2>
			<p className="mb-0">{description}</p>
		</div>
	);
};

export default AuthHeadingPanel;
